<template>
    <label class="custom-checkbox">
        <input
            type="checkbox"
            :checked="value"
            @change="$emit('input', $event.target.checked)"
            hidden
        />
        <span class="checkbox-box">
      <span v-if="value" class="checkmark">✔</span>
    </span>
        <span v-if="label" class="checkbox-label">{{ label }}</span>
    </label>
</template>

<script>
export default {
    name: 'CustomCheckbox',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ''
        }
    }
};
</script>

<style scoped>
.custom-checkbox {
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
}

.checkbox-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background-color: #ffffff;
    border: 1px solid #D9D9D9;
    border-radius: 4px;
    transition: background-color 0.2s;
}

.custom-checkbox input:checked + .checkbox-box {
    background-color: #F5EEE8;
}

.checkmark {
    color: #646464;
    font-size: 16px;
    font-weight: bold;
}

.checkbox-label {
    margin-left: 8px;
    font-size: 16px;
}
</style>